import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PresentationOverviewPage } from '../features/presentations/presentation-authoring-pages';

const OverviewSearchSchema = z.object({ slide: z.string().optional() });

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/overview',
)({ component: RouteComponent, validateSearch: OverviewSearchSchema });
function RouteComponent() {
  const params = Route.useParams();
  const { slide } = Route.useSearch();
  return <PresentationOverviewPage {...params} selectedSlideId={slide} />;
}
